<div
    bsModal
    #createOrEditModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="createOrEditModal"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form #categoryForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span *ngIf="category.id">{{ l('EditCategory') }}</span>

                        <span *ngIf="!category.id">{{ l('CreateNewCategory') }}</span>
                    </h4>

                    <button
                        type="button"
                        class="btn-close"
                        (click)="close()"
                        aria-label="Close"
                        [disabled]="saving"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="my-3">
                        <label class="form-label" for="Category_Code">{{ l('Code') }} *</label>
                        <input
                            type="text"
                            #Category_Code="ngModel"
                            id="Category_Code"
                            class="form-control"
                            [(ngModel)]="category.code"
                            name="Code"
                            minlength="0"
                            maxlength="100"
                            required
                        />
                        <validation-messages [formCtrl]="Category_Code"></validation-messages>
                    </div>

                    <div class="my-3">
                        <label class="form-label" for="Category_Name">{{ l('Name') }} *</label>
                        <input
                            type="text"
                            #Category_Name="ngModel"
                            id="Category_Name"
                            class="form-control"
                            [(ngModel)]="category.name"
                            name="Name"
                            minlength="0"
                            maxlength="300"
                            required
                        />
                        <validation-messages [formCtrl]="Category_Name"></validation-messages>
                    </div>

                    <!-- <div class="my-3">
                        <label class="form-label" for="Category_CategoryImage">{{ l('CategoryImage') }}</label>
                        <input
                            type="text"
                            #Category_CategoryImage="ngModel"
                            id="Category_CategoryImage"
                            class="form-control"
                            [(ngModel)]="category.categoryImage"
                            name="CategoryImage"
                        />
                        <validation-messages [formCtrl]="Category_CategoryImage"></validation-messages>
                    </div> -->
                </div>
                <div class="modal-footer">
                    <button [disabled]="saving" type="button" class="btn btn-danger" (click)="close()">
                        {{ l('Cancel') }}
                    </button>
                    <button
                        type="submit"
                        class="btn btn-primary blue"
                        [disabled]="!categoryForm.form.valid"
                        [buttonBusy]="saving"
                        [busyText]="l('SavingWithThreeDot')"
                    >
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
